import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class UpdateAbacusCourse extends Component {
  state = {
    id: "",
    title: "",
    description: "",
    duration: "",
    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    console.log(id);

    this.setState({ id }, () => {
      this.getSingleCourse();
    });
  }

  /* ---------------- GET SINGLE COURSE ---------------- */
  getSingleCourse = () => {
    if (init() === "success") {
      axios
        .get(Constants.getUrls.getAllAbacusCourses + "/" + this.state.id)
        .then((resp) => {
          if (resp.data.status === "success") {
            const data = resp.data.data;
            this.setState({
              title: data.title || "",
              description: data.description || "",
              duration: data.duration || "",
            });
          }
        })
        .catch(() => {
          this.setState({
            notification: true,
            message: "Failed to load course details",
          });
        });
    }
  };

  /* ---------------- INPUT HANDLER ---------------- */
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  /* ---------------- UPDATE ---------------- */
  handleSubmit = (e) => {
    e.preventDefault();

    if (init() === "success") {
      this.setState({ loading: true });

      axios
        .put(Constants.putUrls.updateAbacusCourse + this.state.id, {
          title: this.state.title,
          description: this.state.description,
          duration: this.state.duration,
        })
        .then((resp) => {
          this.setState({
            notification: true,
            message: resp.data.message,
            loading: false,
          });

          setTimeout(() => {
            this.setState({
              notification: false,
              redirect: true,
            });
          }, 2500);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response?.data?.message || "Update failed",
            loading: false,
          });

          setTimeout(() => {
            this.setState({ notification: false });
          }, 3000);
        });
    }
  };

  handleCloseSnackbar = () => {
    this.setState({ notification: false });
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/abacuscourse" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Abacus Course
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* TITLE */}
                  <Grid item sm={6} xs={12}>
                    <TextField
                      fullWidth
                      type="text"
                      label="Course Title"
                      name="title"
                      focused
                      value={this.state.title}
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* DURATION */}
                  <Grid item sm={6} xs={12}>
                    <TextField
                      fullWidth
                      type="text"
                      label="Duration"
                      name="duration"
                      focused
                      value={this.state.duration}
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* DESCRIPTION */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      label="Description"
                      name="description"
                      focused
                      value={this.state.description}
                      onChange={this.handleInput}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              open={this.state.notification}
              close={this.handleCloseSnackbar}
              color="success"
              icon="notifications"
              title="Abacus Course"
              content={this.state.message}
              dateTime="Just now"
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
